module.exports = __webpack_public_path__ + "assets/plant-level-2.5de7c727.svg";